module.exports = __webpack_public_path__ + "static/media/logo-react.fcc6b4f9.png";